import { render, staticRenderFns } from "./fireDetectionAlarmSystemPid.vue?vue&type=template&id=2e557670"
import script from "./fireDetectionAlarmSystemPid.vue?vue&type=script&lang=js"
export * from "./fireDetectionAlarmSystemPid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e557670')) {
      api.createRecord('2e557670', component.options)
    } else {
      api.reload('2e557670', component.options)
    }
    module.hot.accept("./fireDetectionAlarmSystemPid.vue?vue&type=template&id=2e557670", function () {
      api.rerender('2e557670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/fdas/fireDetectionAlarmSystemPid.vue"
export default component.exports